import { render } from "./SlotRestriction.vue?vue&type=template&id=2d3321cb&scoped=true"
import script from "./SlotRestriction.vue?vue&type=script&lang=js"
export * from "./SlotRestriction.vue?vue&type=script&lang=js"

import "./SlotRestriction.vue?vue&type=style&index=0&id=2d3321cb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d3321cb"]])

export default __exports__